
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"27","height":"27","viewBox":"0 0 27 27"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"search-magnify","clip-path":"url(#clip-path)"}},[_c('rect',{attrs:{"id":"Rectangle_693","data-name":"Rectangle 693","width":"27","height":"27","fill":"none"}}),_c('path',{attrs:{"id":"Path_208","data-name":"Path 208","d":"M26.9,24.531l-5.583-5.583a11.584,11.584,0,0,0,2.369-7.106A11.77,11.77,0,0,0,11.843,0,11.77,11.77,0,0,0,0,11.843,11.77,11.77,0,0,0,11.843,23.686a11.584,11.584,0,0,0,7.106-2.369L24.531,26.9ZM3.384,11.843a8.377,8.377,0,0,1,8.459-8.459A8.377,8.377,0,0,1,20.3,11.843,8.377,8.377,0,0,1,11.843,20.3,8.377,8.377,0,0,1,3.384,11.843Z","fill":"currentColor"}})])])
          )
        }
      }
    